import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { Ellipsis } from '@simplywallst/ui-core';
import { darken } from '@simplywallst/ui-core';

const snowflakeMinWidth = 50;

export const HoldingWrapper = styled('div')`
  border: solid 1px transparent;
  position: relative;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  transition: opacity 0.2s;
  opacity: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(${({ theme }) => theme.color.spaceGray}, 0.9);
`;

export const Tile = styled('section')`
  height: 120px;
  background-color: ${({ theme }) => theme.color.spaceGray};
  padding: ${({ theme }) => theme.x2spacePx}px;
  transition: background-color 0.2s;
  &:hover {
    background-color: rgb(${({ theme }) => darken(theme.color.spaceGray, 0.2)});
  }
`;

export const Header = styled(Row)`
  position: relative;
  padding-left: ${({ theme }) => snowflakeMinWidth + theme.x2spacePx}px;
  height: ${snowflakeMinWidth}px;
`;

export const Footer = styled('footer')`
  position: absolute;
  left: ${({ theme }) => theme.x2spacePx}px;
  bottom: ${({ theme }) => theme.x2spacePx - 2}px;
`;

export const SnowflakeWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0%;
`;

export const Ticker = styled('div')`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.white};
  margin-bottom: -${({ theme }) => theme.x1spacePx / 4}px;
  > span {
    opacity: 0.5;
    margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  }
`;

export const CompanyName = styled('div')`
  ${({ theme }) => theme.typography.baseStrong}
  color: ${({ theme }) => theme.color.white};
  padding-right: ${({ theme }) => theme.x3spacePx}px;
  ${Ellipsis}
`;

interface SubMetaProps {
  noTransactions?: boolean;
}

export const SubMeta = styled('div')<SubMetaProps>`
  ${({ theme }) => theme.typography.xSmallStrong}
  color: ${({ theme }) => theme.color.white};
  display: inline-block;
  min-width: ${({ theme }) => snowflakeMinWidth + theme.x2spacePx}px;
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  ${({ theme, noTransactions }) =>
    noTransactions && `margin-left: -${theme.x2spacePx}px;`}
  > span {
    display: block;
  }
`;

export const SubMetaLabel = styled('span')`
  opacity: 0.5;
  margin-top: -${({ theme }) => theme.x1spacePx / 4}px;
  ${({ theme }) => theme.typography.tiny}
`;

export const MenuButtonContainer = styled('div')`
  position: absolute;
  right: ${({ theme }) => theme.x1spacePx}px;
  top: ${({ theme }) => theme.x2spacePx}px;
  &:hover {
    svg {
      opacity: 1;
    }
  }
  svg {
    opacity: 0.5;
  }
`;

export const Excluded = styled(`p`)`
  ${({ theme }) => theme.typography.tinyStrong}
  color: ${({ theme }) => theme.color.brand01};
  margin: 0;
`;

interface CurrentValueProps {
  liquidated: boolean;
}

export const CurrentValue = styled('span')<CurrentValueProps>`
  color: ${({ theme, liquidated }) =>
    liquidated ? theme.color.neutral : 'inherit'};
`;
